<script>
import UserResource from '@/resources/user'
import ChangePasswordForm from '../components/ChangePasswordForm.vue'

export default {
    name: 'ChangePassword',
    components: {
        ChangePasswordForm
    },
    data() {
        return {
            loading: true,
            userResource: null,
        }
    },
    methods: {
        onSuccess() {
            this.$router.push({ name: 'dashboard' })
        }
    },
    async mounted() {
        this.loading = true
        this.userResource = await UserResource.detail(this.$store.getters.userId)
        this.loading = false
    }
}
</script>

<template>
    <b-container>
        <b-row>
            <b-col lg="4" offset-lg="4" class="mt-5">
                <change-password-form @success="onSuccess" :userResource="userResource" v-if="!loading" />
                <p v-else class="text-center">Cargando...</p>
            </b-col>
        </b-row>
    </b-container>
</template>

